// Resumo da tela de Pedidos vindo do SERVIDOR, com os filtros da tela.
//
// Antes os cards eram calculados no navegador sobre os 500 pedidos carregados:
// filtrar por iFood dava "o faturamento do iFood dentro dos últimos 500", e
// nada avisava. Agora quem soma é o banco, sobre o conjunto inteiro.
import { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = "/api";
const ESPERA_MS = 350;

export function useResumoPedidos(filtros) {
  const [stats, setStats] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const chave = JSON.stringify(filtros || {});
  const ultimaChave = useRef(null);

  useEffect(() => {
    let vivo = true;
    // Debounce: a busca textual muda a cada tecla.
    const id = setTimeout(async () => {
      if (ultimaChave.current !== chave) setCarregando(true);
      ultimaChave.current = chave;
      try {
        const token = localStorage.getItem("token");
        const { data } = await axios.get(`${API}/pedidos/stats`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          params: JSON.parse(chave),
        });
        if (vivo) setStats(data);
      } catch {
        /* mantém o último resumo bom em vez de zerar a tela */
      } finally {
        if (vivo) setCarregando(false);
      }
    }, ESPERA_MS);
    return () => { vivo = false; clearTimeout(id); };
  }, [chave]);

  return { stats, carregando };
}
